export default class Pathes {
  static Posts = class {
    static list = '/articles/';
    static detail = slug => `/articles/${slug}/`;
  };
}